import { render } from "./ConfirmPopup.vue?vue&type=template&id=24fc3c9f&scoped=true"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js"

import "./ConfirmPopup.vue?vue&type=style&index=0&id=24fc3c9f&lang=css&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fc3c9f"]])

export default __exports__